module.exports = __webpack_public_path__ + "static/media/colorful_5.29de1d66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/colorful/colorful_5.jpg
// module id = 530
// module chunks = 0